import { resolveToolbarBtnProps, resolveToolbarBtnIcon } from '@/utils/toolbarButtonGroups'
import { resolveToolbarFieldPlaceholder } from '@/utils/toolbarFieldWidth'

/**
 * 自定义筛选条（toolbar-filter-bar）按钮样式与图标。创建于 2026-08-28
 */
export default {
  methods: {
    toolbarBtnType(item) {
      return resolveToolbarBtnProps(item).type
    },
    toolbarBtnIcon(item) {
      return resolveToolbarBtnIcon(item)
    },
    fieldPlaceholder(item) {
      return resolveToolbarFieldPlaceholder(item || {})
    },
  },
}
